import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { FOOTER_BANNER_WEB } from "../../helpers/brazePlacementIds";
import BrazePlacementBanner from "../UserSelections/BrazePlacementBanner";
import styles from "./footerBrazeBanner.module.scss";

type FooterBrazeBannerProps = {
  onShowChange?: (show: boolean) => void;
};

/** Desktop-only inline banner directly above the site footer (1320×204). */
const FooterBrazeBanner: React.FC<FooterBrazeBannerProps> = ({
  onShowChange,
}) => {
  const isMobile = useCheckMobileScreen();

  useEffect(() => {
    if (isMobile) onShowChange?.(false);
  }, [isMobile, onShowChange]);

  if (isMobile) return null;

  return (
    <Container fluid style={{ padding: "0px 45px 0px 45px" }}>
      <BrazePlacementBanner
        placementId={FOOTER_BANNER_WEB}
        className={styles.footerBrazeBannerSlot}
        ariaLabel="Footer promotion"
        logLabel="FooterBrazeBanner"
        onShowChange={onShowChange}
      />
    </Container>
  );
};

export default FooterBrazeBanner;
